export default __webpack_public_path__ + "static/assets/7e9a4f3ddd245700e5761e138c43c8b9.svg";